<template>
  <div>
    <h3 class="header-title">Learning Attendance</h3>
    <label>Let’s see your tuition teacher attendance.</label>
    <br />
    <div class="custom-explore">
      <div>
        <CRow>
          <CCol sm="12">
            <div style="width: 80%" class="float-left">
              <img
                src="../assets/img/iconnoti.svg"
                class="ml-5 mr-2 mb-3 mt-3"
              />
              <span class="text-white mt-3 mb-2"> | </span>
              <label class="ml-2 text-white mt-3 mb-2"
                >Explore more on your attendance teacher !</label
              >
            </div>
            <div style="width: 20%" class="float-right p-0">
              <br /><br />
              <img
                src="../assets/img/icontriangle.svg"
                class="ml-5 mr-2"
                style="
                  position: absolute;
                  top: 0;
                  right: 100px;
                  bottom: 0;
                  height: 55px;
                "
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </div>
    <div v-if="Busy == true">
      <CCol sm="12" md="12">
        <div class="app flex-row align-items-center">
          <div class="container d-flex justify-content-center">
            <PulseLoader float />
          </div>
        </div>
      </CCol>
    </div>
    <div v-else>
      <CCol sm="12" class="mt-4">
        <CRow>
          <CCol sm="4">
            <CInput
              type="text"
              placeholder="Search text"
              v-model.lazy="SearchQuery"
              @change="ApplyFilter()"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="3">
            <v-select
              v-model="selectedGrade"
              :options="gradeOptions"
              label="Class"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select>
          </CCol>

          <!-- <CCol sm="3">
            <v-select
              v-model="selectedClass"
              :options="classOptions"
              label="Class"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select>
          </CCol> -->
          <CCol sm="3">
            <v-select
              v-model="selectedTeacher"
              :options="teacherOptions"
              label="Teacher"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select>
          </CCol>

          <CCol sm="3">
            <vue-json-to-csv
                    :json-data="attendanceReport"
                    :labels="{
                      CheckIn: {
                        title: 'Date of attendance taken',
                      },
                      SubjectName: { title: 'SubjectName' },
                      Teacher: {
                        title: 'Teacher',
                      },
                      IsAttend: { title: 'Attend' },
                      TuitionCenterId : { title: 'TuitionCenterId' }
                    }"
                    @success="(val) => DownloadSuccess()"
                    @error="(val) => DownloadFail(val)"
                  >
                    <CButton color="info" class="mt-2 float-right"
                      >Download Report</CButton
                    >
                  </vue-json-to-csv>
 </CCol>
        </CRow>
      </CCol>

      <CCol sm="12">
        <CDataTable
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          :items="FilteredAttendanceList"
          :fields="fields"
          items-per-page-select
          :items-per-page="small ? 5 : 10"
          :dark="dark"
          clickable-rows
          sorter
          pagination
          id="tabledata"
        >
          <template #Subject="{ item }">
            <td>
              <h6 style="color: #1e109c" class="text-uppercase">
                {{ item.SubjectName }}
              </h6>
              <!-- <div class="small text-muted">Grade : {{ item.Grade }}</div>
              <div class="small text-muted">Class : {{ item.Class }}</div> -->
            </td>
          </template>

          <template #Teacher="{ item }">
            <td>
              {{ item.Teacher }}
            </td>
          </template>
          <template #ScheduleDateTime="{ item }">
            <td>
              {{ item.ScheduleDateTime | moment("DD/MM/YYYY hh:mm A") }}
            </td>
          </template>

          <template #CheckIn="{ item }">
            <td>
              {{ item.CheckIn | moment("DD/MM/YYYY hh:mm A") }}
            </td>
          </template>

          <template #CheckOut="{ item }">
            <td>
              {{ item.CheckOut | moment("DD/MM/YYYY hh:mm A") }}
            </td>
          </template>
          <template #IsAttend="{ item }">
            <td>
              <CBadge v-if="item.IsAttend == 'Yes'" color="success">Yes</CBadge>
              <CBadge v-else color="danger">No</CBadge>
            </td>
          </template>
          <template #Action="{ item }">
            <td>
              <CButton
                type="button"
                class="btn btn-success ml-3"
                @click="UpdateAttendTeacher(item)"
              >
                Attend</CButton
              >
              <CButton
                type="button"
                class="btn btn-danger ml-3"
                @click="UpdateNotAttendTeacher(item)"
              >
                Not Attend</CButton
              >
            </td>
          </template>
        </CDataTable>
      </CCol>
    </div>
  </div>
</template>


<script>

import Vue from "vue";
import _ from "lodash";
Vue.use(require("vue-moment"));
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import $ from "jquery";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import VueJsonToCsv from "vue-json-to-csv";
import VuePapaParse from "vue-papa-parse";
Vue.use(VuePapaParse);



export default {
  name: "Tables",
  components: {
    PulseLoader,
     VueJsonToCsv,
  },
  data() {
    return {
      attendance: [],
      SearchQuery: "",
      FilteredAttendance: [],

      perPage: 10,
      pagination: {},
      currentPage: 1,

      selectedGrade: "ALL GRADE",
      gradeOptions: [],

      selectedClass: "ALL CLASS",
      classOptions: [],

      selectedTeacher: "ALL TEACHER",
      teacherOptions: [],

      Busy: false,
      attendanceReport: [],

      fields: [
        { key: "Subject" },
        { key: "Teacher" },
        { key: "ScheduleDateTime" },
        { key: "CheckIn" },
        { key: "CheckOut" },
        { key: "IsAttend" },
        { key: "Action" },
      ],
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetAttendance();
      this.GetAttendanceReport();
    } else {
      this.GoToLogin();
    }
  },
  computed: {
    FilteredAttendanceList() {
    if (this.SearchQuery === '') return this.FilteredAttendance;

    return this.FilteredAttendance.filter(item => {
        // Ensure that properties are not null/undefined before calling toLowerCase
        const subjectName = item.SubjectName?.toLowerCase() || '';  // Fallback to empty string
        const grade = item.Grade?.toLowerCase() || '';
        const className = item.Class?.toLowerCase() || '';
        const teacher = item.Teacher?.toLowerCase() || '';

        // Check if any field contains the search query
        if (subjectName.indexOf(this.SearchQuery.toLowerCase()) > -1) {
            return true;
        }

        if (grade.indexOf(this.SearchQuery.toLowerCase()) > -1) {
            return true;
        }

        if (className.indexOf(this.SearchQuery.toLowerCase()) > -1) {
            return true;
        }

        if (teacher.indexOf(this.SearchQuery.toLowerCase()) > -1) {
            return true;
        }

        return false;  // Return false if no matches found
    });
}


  },
  methods: {
    GetAttendance() {
      this.Busy = true;
      this.$API
        .get(this.$ViewAttendanceTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
              this.Busy = false;
            this.attendance = response.data;
            
            this.FilteredAttendance = this.attendance;

            var gradeNames = _.uniq(_.map(response.data, "Grade"));
            gradeNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.gradeOptions = gradeNames;
            this.gradeOptions.unshift("ALL GRADE");

            var teacherNames = _.uniq(_.map(response.data, "Teacher"));
            teacherNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.teacherOptions = teacherNames;
            this.teacherOptions.unshift("ALL TEACHER");
          }


            if(this.SearchQuery != "")
            {
              var arr = _.orderBy(this.attendance, ["SubjectName"], ["asc"]);
            if (_.isEmpty(arr) == false) {
              const result = _.filter(arr, ({ SubjectName, Grade, Class, Teacher }) =>
                _.some([
                  _.includes(!SubjectName || SubjectName.toLowerCase(), [
                    this.SearchQuery.toLowerCase(),
                  ]),
                  _.includes(!Grade || Grade.toLowerCase(), [
                    this.SearchQuery.toLowerCase(),
                  ]),
                  _.includes(!Class || Class.toLowerCase(), [
                    this.SearchQuery.toLowerCase(),
                  ]),
                  _.includes(!Teacher || Teacher.toLowerCase(), [
                    this.SearchQuery.toLowerCase(),
                  ]),
                ])
              );
              this.FilteredAttendance = result;

              }
            }

            if(this.selectedGrade != "")
            {
              if (this.selectedGrade !== "ALL GRADE")
              this.FilteredAttendance = _.filter(
                this.FilteredAttendance,
                (item) => item.Grade === this.selectedGrade
              );
            }

            if(this.selectedTeacher != "")
            {
              if (this.selectedTeacher !== "ALL TEACHER")
              this.FilteredAttendance = _.filter(
                this.FilteredAttendance,
                (item) => item.Teacher === this.selectedTeacher
              );

            }
        });
    },
    GetAttendanceReport() {
      this.BusyReport = false;
      this.$API
        .get(this.$GetAttendanceReportTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
           this.Busy = false;
            this.attendanceReport = response.data;
          
          }
        });
    },
    ApplyFilter: function () {
      var arr = _.orderBy(this.attendance, ["SubjectName"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, ({ SubjectName, Grade, Class, Teacher }) =>
                _.some([
                  _.includes(!SubjectName || SubjectName.toLowerCase(), [
                    this.SearchQuery.toLowerCase(),
                  ]),
                  _.includes(!Grade || Grade.toLowerCase(), [
                    this.SearchQuery.toLowerCase(),
                  ]),
                  _.includes(!Class || Class.toLowerCase(), [
                    this.SearchQuery.toLowerCase(),
                  ]),
                  _.includes(!Teacher || Teacher.toLowerCase(), [
                    this.SearchQuery.toLowerCase(),
                  ]),
                ])
              );
        this.FilteredAttendance = result;
      }
    },
    FilteredData() {
      console.log("masuk");
      this.FilteredAttendance = this.attendance;

      if (this.selectedGrade !== "ALL GRADE")
        this.FilteredAttendance = _.filter(
          this.FilteredAttendance,
          (item) => item.Grade === this.selectedGrade
        );

      if (this.selectedClass !== "ALL CLASS")
        this.FilteredAttendance = _.filter(
          this.FilteredAttendance,
          (item) => item.Class === this.selectedClass
        );

      if (this.selectedTeacher !== "ALL TEACHER")
        this.FilteredAttendance = _.filter(
          this.FilteredAttendance,
          (item) => item.Teacher === this.selectedTeacher
        );
    },
    UpdateAttendTeacher: function (item) {
      this.AttendanceId = item.Id;
      this.TeacherId = item.TeacherId;
      const formData = new FormData();
      formData.append("id", this.AttendanceId);
      formData.append("teacherID", this.TeacherId);
      formData.append("isAttend", true);


      return this.$API
        .post(this.$UpdateTeacherAttendanceBackup, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.RefreshData();
            // this.$dialog.alert("Success save").then(function () {});
           
          } else {
            this.$dialog.alert("Error ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    UpdateNotAttendTeacher: function (item) {
      this.AttendanceId = item.Id;
      this.TeacherId = item.TeacherId;
      const formData = new FormData();
      formData.append("id", this.AttendanceId);
      formData.append("teacherID", this.TeacherId);
      formData.append("isAttend", false);

      return this.$API
        .post(this.$UpdateTeacherAttendanceBackup, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
         this.RefreshData();
            // this.$dialog.alert("Success saved");
          } else {
            this.$dialog.alert("Error saved");
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    RefreshData() {
      this.GetAttendance();
      this.ApplyFilter();
      this.attendance.filter(aSpace => aSpace.SubjectName == this.SearchQuery)
    
    },
    showFullMats () {
      this.prevPage = this.pagination.page;
      this.$nextTick().then(()=>{
        this.$set(this.pagination, 'page', this.prevPage);
      });
  }
  },
};
</script>
<style>
.style-chooser .vs__open-indicator {
  fill: rgb(251 248 254);
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: -webkit-transform 150ms
    cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855),
    -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  -webkit-transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
  transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
}
.style-chooser .vs__clear {
  fill: rgb(251 248 254);
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  margin-right: 8px;
}
.style-chooser .vs__dropdown-toggle {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 0 0 4px 0;
  background: none;
  border: 1px solid #009efb;
  border-radius: 4px;
  white-space: normal;
  height: 36px;
}
.style-chooser .vs__selected {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #009efb;
  border: 1px solid #009efb;
  border-radius: 4px;
  color: #fff;
  line-height: 1.4;
  margin: 4px 2px 0px 2px;
  padding: 0 0.25em;
  z-index: 0;
}
.style-chooser .vs__single .vs__selected {
  background-color: #009efb;
  border-color: #009efb;
}
.custom-btn-blue {
  background: #009efb;
  border: 1px solid #009efb;
  color: #ffffff;
  border-radius: 4px;
}
</style>
